import React from 'react';
import SelectionOverlay from './SelectionOverlay';
import SelectionsController from './SelectionsController';
import {
  ApplicationView,
  useController,
  StartControllerScope,
} from '@aha-app/mvc';
import { type Editor } from 'slate';
import styles from '../../components/AhaEditorV2.module.css';
import './selection-styles.css';

export interface SelectionsProps {
  editor: Editor;
}

const Selections: React.FC<SelectionsProps> = ({ editor }: SelectionsProps) => {
  const controller = useController(SelectionsController);
  const { selections } = controller.state;

  if (Object.keys(selections).length === 0) return null;

  return (
    <div className={styles.selections}>
      {Object.values(selections).map((selection) => (
        <SelectionOverlay
          key={selection.selectionId}
          editor={editor}
          selection={selection}
        />
      ))}
    </div>
  );
};

export default StartControllerScope(
  SelectionsController,
  ApplicationView(Selections)
);
